<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:60%;margin-left:5%;">
<el-form :label-position="labelPosition" label-width="120px" :model="dataS[0]" style="width:75%;" >
       <el-form-item label="发票寄送地址" >
       <el-input v-if="dataS[0].request.email != '' && dataS[0].request.email != null && dataS[0].request.email != undefined " :value="dataS[0].request.email" size="small" disabled></el-input>
        <el-input v-if="dataS[0].request.email == '' || dataS[0].request.email == null || dataS[0].request.email == undefined  " value="用户暂未填写" size="small" disabled></el-input>
    </el-form-item>
       <el-form-item label="流水号" >
       <el-input v-model="dataS[0].request.fpqqlsh" size="small" disabled></el-input>
    </el-form-item>
       <el-form-item label="发票号码" >
       <el-input v-model="dataS[0].request.fphm" size="small" disabled></el-input>
    </el-form-item>
    <el-form-item label="抬头名称" >
       <el-input v-model="dataS[0].request.gmfMc" size="small" disabled></el-input>
    </el-form-item>
    <el-form-item label="开票日期(税盘)" >
       <el-input v-model="dataS[0].request.kprq" size="small" disabled></el-input>
    </el-form-item>
    <el-form-item label="账单周期" >
       <el-input v-model="dataS[0].zq" size="small" disabled></el-input>
    </el-form-item>
    <el-form-item label="开票状态" >
       <el-input v-if="dataS[0].request.invoiceStatus == '2'" value="开票中" size="small" disabled></el-input>
        <el-input v-if="dataS[0].request.invoiceStatus == '3'" value="开票失败" size="small" disabled></el-input>
         <el-input v-if="dataS[0].request.invoiceStatus == '4'" value="开票成功" size="small" disabled></el-input>
          <el-input v-if="dataS[0].request.invoiceStatus == '5'" value="封张待开" size="small" disabled></el-input>
           <el-input v-if="dataS[0].request.invoiceStatus == '' || dataS[0].request.invoiceStatus ==null || dataS[0].request.invoiceStatus == undefined " value="未开" size="small" disabled></el-input>
    </el-form-item>
</el-form>
</div>
  <div>
      <el-table tooltip-effect="light"  :data="this.dataS[0].invoiceOfflineOrderVOS"     style="overflow-y: scroll;float:right;margin-top:30px" 
  row-key="id"   :default-expand-all="false"  :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}" :stripe="true" :tree-props="{children: 'children'}" >
    <el-table-column show-overflow-tooltip  prop="id" label="编号"  ></el-table-column>
    <el-table-column show-overflow-tooltip  prop="floorName" label="楼栋号"></el-table-column>
    <el-table-column show-overflow-tooltip  prop="roomName" label="房间号"></el-table-column>
    <el-table-column show-overflow-tooltip  prop="cusName" label="业主"></el-table-column>
    <el-table-column show-overflow-tooltip  prop="feeName" label="收费项目"></el-table-column>
    <el-table-column show-overflow-tooltip  prop="zjJe" label="费用"></el-table-column>
    <el-table-column show-overflow-tooltip  prop="zjCny" label="应收年月"></el-table-column>
    <el-table-column show-overflow-tooltip  prop="zjSkrq" label="收费日期"></el-table-column>
    <el-table-column show-overflow-tooltip  prop="zjSkrq" label="销账状态">
          <template slot-scope="scope">
        <el-tag v-if="scope.row.zjSkrq == null" >未销账</el-tag>
        <el-tag v-if="scope.row.zjSkrq != null" >已销账</el-tag>
      </template>
    </el-table-column>
    <el-table-column show-overflow-tooltip  prop="zjRemarks" label="备注"></el-table-column>
  </el-table>
  </div>
      <span slot="footer" class="dialog-footer" >
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "BillStorageDialog",
  data() {
    return {
    ifelse:true,
    checked: true,
    options:[],
    value:"",
    BillDateTime:"",
    optionsone: [],
    valueone: '',
    dialogVisible: false,
    title:"标题",
    titleone:"",
    labelPosition:'right',
    formLabelAlign:{},
    type:"",
    mangroupId:"",
    Pid:"",
    mangroupName:"",
    typeId:"",
    typeName:"",
    groupId:"",
    BillTypeList:[],
    BillTypevalue:"",
    dataS:[],
    tableData:[]
    };
  },
watch:{
    dialogVisible(val){
        if(val == true){
        }
    }
},
  methods: {
    modification(){
        this.dialogVisible = false
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    amend(){
    }
  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {
  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>